import React from "react";
import { FaCircle } from "react-icons/fa";
import Binacle from "../assets/Binacle.webp";

const About = () => {
  return (
    <div
      name="education"
      className="w-full h-min-screen bg-gradient-to-b from-black to-slate-800 text-white"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Experiance
          </p>
        </div>
        
        <div className="bg-gradient-to-b from-sky-100 to-teal-200 rounded-lg shadow-md p-6">
            <a href="https://www.binacle.games/" target="blank"><img
              src={Binacle}
              alt="my profile"
              className="rounded-2xl mb-9"
            /></a>
          <h2 className="text-xl text-gray-600 font-bold">
          <a href="https://www.binacle.games/" target="blank">Bincale Pte. Ltd (Jul 2023 - Feb 2025) - 1 year and 6 months</a>
          
          </h2>
          <ul className="text-gray-600 mt-2 ml-10">
          <li className="flex items-center">
              <span className="mr-2">
                <FaCircle size={10} />
              </span>
              Junior Game Designer/ Developer (Full-time) - Bincale Pte. Ltd (February 2024 - February
                2025) - 1 year
            </li>
            <li className="flex items-center">
              <span className="mr-2">
                <FaCircle size={10} />
              </span>
              Internship - Bincale Pte. Ltd (Jul 2023 - Jan 2024) - 6 months
            </li>
          </ul>
        </div>

        <div className="pb-8 mt-11">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Education
          </p>
        </div>

        <div className="bg-gradient-to-b from-sky-100 to-teal-200 rounded-lg shadow-md p-6">
          <h2 className="text-xl text-gray-600 font-bold">
            B.Sc. (Hons) in Computer Science, University of Plymouth
          </h2>
          <ul className="text-gray-600 mt-2 ml-10">
            <li className="flex items-center">
              <span className="mr-2">
                <FaCircle size={10} />
              </span>
              Programming Languages: C, C#, Python (Data Structures and
              Algorithms).
            </li>
            <li className="flex items-center">
              <span className="mr-2">
                <FaCircle size={10} />
              </span>
              Full-Stack Web and Desktop Application Development:
            </li>
            <ul className="ml-10">
              <li>
                Languages/Frameworks: PHP, .NET, .NET Core, Angular, Node.js
              </li>
            </ul>
            <li className="flex items-center">
              <span className="mr-2">
                <FaCircle size={10} />
              </span>
              Machine Learning Concepts:
            </li>
            <ul className="ml-10">
              <li>
                Algorithms: K-Nearest Neighbors (KNN), K-Means, Decision Trees
              </li>
              <li>Software: MATLAB</li>
            </ul>
            <li className="flex items-center">
              <span className="mr-2">
                <FaCircle size={10} />
              </span>
              Big Data Analytics:
            </li>
            <ul className="ml-10">
              <li>Tools: Jupyter Notebook</li>
              <li>Experience: Simulations and Data Set Preparation</li>
            </ul>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default About;
